<template>
    <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <keep-alive>
          <DataTableMainServer
            :datatable="table"
            :on-success="SuccessTableAction"
            :itemsAction="SuccessTableAction"
            :Updatepagination="params"
            :on-pagination="pagePagination"
            :on-search="getSearchPagePagination"
          />
          <ViewDetails :object="object" type="DetailEquipo" />
          <Breadcrumb v-if="showTree" />
        </keep-alive>
        <v-dialog v-model="colorDialog" max-width="370px">
            <v-card>
              <v-card-title class="headline">Selecciona un color</v-card-title>
              <v-card-text>
                <v-color-picker v-model="selectedColor" show-swatches></v-color-picker>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="colorDialog = false">Cancelar</v-btn>
                <v-btn color="primary" @click="saveColor">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-row>
    <v-col cols="4" class="d-flex justify-end ml-auto pa-5 ma-0 mt-0 pt-2" style="border: 1px solid white; padding: 0; margin: 0;">
      <v-switch
        v-model="showDisabled"
        :label="showDisabled ? 'Mostrando desactivados' : 'Ocultando desactivados'"
        inset
        @change="refreshData"
        hide-details
      ></v-switch>
    </v-col>
  </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMainServer from '@/components/tables/DataTableMainServer'
import ViewDetails from '@/components/ViewDetails'
import Breadcrumb from '@/components/Arbol/Breadcrumb' // Asegúrate de que esta ruta es correcta

export default {
  mixins: [Permission],
  data: () => ({
    colorDialog: false, // Controla la visibilidad del diálogo de colores
    selectedColor: '', // Almacena el color seleccionado
    selectedItem: null, // Guarda el ítem para actualizar su color
    openDialog: false,
    showTree: true,
    showDisabled: false, // Controla la visibilidad del árbol
    table: {
      modelMain: [],
      showSelect: false,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'espacio.entry' }
          // { title: 'Ver Desactivados/Ocultar', icon: 'mdi-eye-off', color: 'red', action: 'viewDisabled', code: 'espacio.refresh' }
        ],
        titles: [
          { text: 'Nombre del espacio', value: 'descripcion.nombreE', class: 'black--text' },
          { text: 'Responsable', value: 'descripcion.responsable.NombreCompleto', class: 'black--text' },
          { text: 'Telefono', value: 'descripcion.responsable.caracteristicas.telefono', class: 'black--text' },
          { text: 'activo', value: 'activo', class: 'black--text' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Ver Deportes', icon: 'mdi-soccer', color: 'blue', action: 'toDeportes', code: 'next.deporte' },
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'toUpdate', code: 'espacio.edit' },
          { title: 'Elegir Color', icon: 'mdi-palette', color: 'purple', action: 'openColorPicker', code: 'color.edit' },
          // { title: 'Plantilla', icon: 'mdi-cards-variant', color: 'red', action: 'Plantilla1', code: 'new.plantilla' },
          { title: 'Agregar Integrante', icon: 'mdi-account-plus', color: 'success', action: 'newEncargado', code: 'create.integrante' },
          { title: 'Activar / Desactivar', icon: 'mdi-contrast-circle', color: 'grey darken-3', action: 'disableData', code: 'disable.espacio' }
        ]
      },
      footer: {
        paging: true
      }
    },
    params: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    default: { groupBy: [], groupDesc: [], itemsPerPage: 10, multiSort: false, mustSort: false, page: 1, sortBy: [], sortDesc: [] },
    user: {}
  }),
  components: {
    DataTableMainServer,
    ViewDetails,
    Breadcrumb // Asegúrate de que el nombre sea correcto
  },
  mounted () {
    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'POSTPagination']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES', 'SHOW_DIALOG_REPORT', 'SHOW_DIALOG_ALERT_MAIN']),
    SuccessTableAction (item) {
      console.log('Acción ejecutada:', item.action)
      this[item.action](item)
    },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.POSTPagination({ url: router, data: this.params })
      } else { this.getUrlServices() }
    },
    pagePagination (val) {
      this.table.header.loading = true
      if (val) this.params = val
      else this.params = this.default
      this.ExecuteUrl('espacio.list-pagination')
    },
    getSearchPagePagination (val) {
      this.table.header.loading = true
      this.params = val
      this.ExecuteUrl('espacio.list-pagination')
    },
    // filterData (item) {
    //   this.SHOW_DIALOG_MAIN({
    //     type: 'filter',
    //     with: '60%',
    //     title: 'FILTRAR',
    //     body: {
    //       objectMain: this.filterTableData,
    //       paramsDialog: {
    //         form: this.get_InventariosEquiposFilterForm,
    //         message: 'Registro Agregado Correctamente',
    //         returnObject: true,
    //         setmodel: true
    //       }
    //     }
    //   })
    // },
    openColorPicker (item) {
      console.log('Abriendo selector de color para:', item)
      this.selectedItem = item.item // Guarda el ítem seleccionado
      this.selectedColor = item.item.color || '#ffffff' // Usa el color actual o blanco
      this.colorDialog = true // Abre el diálogo
      console.log('colorDialog:', this.colorDialog) // Verificar si cambia
    },
    saveColor () {
      if (!this.selectedItem) return

      const url = this.get_urls['espacio.color']
      if (!url) {
        console.error('❌ Error: No se encontró la URL para guardar el color.')
        return
      }

      this.POSTPagination({
        url,
        data: {
          id: this.selectedItem.id,
          color: this.selectedColor
        }
      })
        .then(() => {
          console.log('✅ Color guardado correctamente')
          this.selectedItem.color = this.selectedColor
          this.colorDialog = false
        })
        .catch(err => console.error('❌ Error al guardar el color:', err))
    },
    toDeportes (item) {
      const espacioId = { id: item.item.id, nombre: item.item.nombre }
      this.$emit('viewDeportes', espacioId)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.params.showDisabled = this.showDisabled
      this.ExecuteUrl('espacio.list-pagination')
    },
    viewDisabled () {
      this.showDisabled = !this.showDisabled // Cambia el estado
      this.refreshData() // Actualiza los datos mostrados
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        form: 'process',
        with: '50%',
        title: 'Nuevo Espacio',
        body: {
          objectMain: { tipo_actividad_id: 1, empresa_id: this.user.empresa_id, user: this.user.usuario_id },
          paramsDialog: {
            url: this.get_urls['espacio.execute'],
            urloption: this.get_urls['espacio.options'],
            process: 1, // comienzo del proceso del status detonante
            actividad: 1,
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            onSuccess: () => { // Callback de éxito
              this.refreshData()
            }
          }
        }
      })
    },
    toUpdate (item) {
      console.log('Datos antes:', item)
      console.log('Responsable:', item.item.descripcion.responsable)
      const data = {
        id: item.item.id || '',
        nombreE: item.item.descripcion.nombreE,
        calle: item.item.descripcion.domicilio.calle,
        user: this.user.usuario_id,
        color: item.item.descripcion.color,
        numero: item.item.descripcion.domicilio.numero,
        cp: item.item.descripcion.domicilio.cp,
        cruzamiento1: item.item.descripcion.domicilio.cruzamiento1,
        cruzamiento2: item.item.descripcion.domicilio.cruzamiento2,
        tipo_actividad_id: item.item.categoria_id,
        empresa_id: item.item.empresa_id,
        responsable: item.item.descripcion.responsable?.id || '', // ID del responsable seleccionado
        responsableE: { // Objeto para inicializar el campo (opcional si el componente lo requiere)
          id: item.item.descripcion.responsable?.id || '',
          NombreCompleto: item.item.descripcion.responsable?.NombreCompleto || '' // Nombre visible del responsable
        }
      }
      console.log('Datos a enviar para actualización:', data)
      const tituloDialogo = `Editar Espacio de ${item.item.descripcion.nombreE || 'desconocido'}`
      this.SHOW_DIALOG_MAIN({
        type: 'update',
        form: 'process',
        with: '60%',
        title: tituloDialogo,
        body: {
          objectMain: data,
          paramsDialog: {
            url: this.get_urls['espacio.execute'],
            urloption: this.get_urls['espacio.options'],
            process: 1,
            actividad: item.item.categoria_id,
            message: 'Registro Actualizado Correctamente',
            updated: true,
            setmodel: true
          }
        }
      })
    },
    disableData  ({ item }) {
      const name = (item.activo === 'si') ? 'Desactivar' : 'Activar'
      this.SHOW_DIALOG_ALERT_MAIN({
        type: 'disable',
        with: '40%',
        title: `${name} Espacio`,
        body: {
          objectMain: item,
          url: this.get_urls['espacio.up-down'],
          message: `¿Estás seguro en ${name} el registro?`,
          description: ''
        },
        confirmButtonText: `Sí, ${name}`,
        cancelButtonText: 'No, Cancelar'
      })
    },
    newEncargado (item) {
      console.log('empleado', this.user.empleado_id)
      const data = {
        empleado_id: this.user.empleado_id,
        item: item
      }
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: 680,
        title: 'Nuevo Empleado',
        body: {
          objectMain: data,
          paramsDialog: {
            form: this.get_EmpleadoForm,
            url: this.get_urls['empresa.empleados.create'],
            message: 'Registro Agregado Correctamente',
            updated: true,
            returnObject: true,
            setmodel: true
          }
        }
      })
    }
    // Plantilla1 ({ item }) {
    //   console.log('item:', item)
    //   this.SHOW_DIALOG_MAIN({
    //     type: 'charge',
    //     form: 'process',
    //     with: '50%',
    //     title: 'Documentacion',
    //     body: {
    //       objectMain: { num: 1, item, slug: 'esp' },
    //       paramsDialog: {
    //         url: this.get_urls['documentos.execute'],
    //         urloption: this.get_urls['documentos.options'],
    //         setmodel: true,
    //         data: item.item
    //       }
    //     }
    //   })
    // }
    // Otros métodos
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objectPagination', 'get_objects',
      'get_EspaciosForm', 'get_TicketsUuAaForm', 'get_ReporteGeneralInventariablesForm', 'get_EmpleadoForm', 'get_PlantillaForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    colorDialog (newVal) {
      console.log('Cambio en colorDialog:', newVal)
    },
    get_urls (val) { this.refreshData({}) },
    get_objectPagination (rows) {
      if (rows) {
        this.table.body.data = []
        this.table.header.loading = false
        this.table.body.data = rows.data
        this.params.page = rows.current_page
        this.params.total = rows.total
      }
    }
  }
}
</script>
<style scoped>
.custom-switch .v-input__control {
  background-color: #d21985 !important; /* Color de fondo cuando está desactivado */
}

.custom-switch .v-input__track {
  background-color: #B0BEC5 !important; /* Color de fondo cuando está activado */
}
</style>
